import React, { useEffect, useState } from 'react';
import '../styles/MyShows.css';
import '../styles/Home.css';
import COLORS from '../styles/colors.js';
import { useNavigate } from 'react-router-dom';
import { FaCalendarAlt, FaEdit } from 'react-icons/fa';

const MyShows = () => {
    const navigate = useNavigate();
    const [shows, setShows] = useState([]);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(null);
    const [isAuthorized, setIsAuthorized] = useState(false);

    // Logged-in user ID from localStorage (check both keys for compatibility)
    const userId = localStorage.getItem('user_id') || localStorage.getItem('userId');

    // Redirect to login if not logged in
    useEffect(() => {
        if (!userId) {
            console.log('No user_id found, redirecting to login');
            navigate('/user-login', { replace: true });
            setIsAuthorized(false);
        } else {
            setIsAuthorized(true);
        }
    }, [userId, navigate]);

    useEffect(() => {
        if (!userId) return; // Don't fetch if not logged in

        const fetchShows = async () => {
            try {
                setLoading(true);
                setError(null);

                const baseUrl = (process.env.REACT_APP_BACKEND_API || '').replace(/\/$/, '');
                const response = await fetch(`${baseUrl}/shows/`);

                if (!response.ok) {
                    throw new Error('Failed to fetch shows');
                }

                const data = await response.json();

                // Filter shows where logged user is a co-host
                const filteredShows = data.filter(show => {
                    return Array.isArray(show.co_hosts) &&
                        show.co_hosts.some(host => String(host.id) === String(userId));
                });

                setShows(filteredShows);
                setLoading(false);
            } catch (err) {
                console.error('Error fetching shows:', err);
                setError(err.message);
                setLoading(false);
            }
        };

        fetchShows();
    }, [userId]);

    return (
        <div className="home-wrapper">
            <h3 style={{ marginBottom: 40, marginTop: 24 }}>My Co-Hosted Shows</h3>

            {loading && <div className="loading-block">Loading...</div>}
            {error && <div className="error-block">{error}</div>}

            {!isAuthorized && !loading && (
                <div style={{
                    textAlign: 'center',
                    padding: '40px 20px',
                    backgroundColor: '#f8f9fa',
                    borderRadius: '8px',
                    marginTop: '20px'
                }}>
                    <p>Redirecting to login...</p>
                </div>
            )}

            {isAuthorized && !loading && !error && (
                <div>
                    {shows.length === 0 ? (
                        <div style={{
                            textAlign: 'center',
                            padding: '40px 20px',
                            backgroundColor: '#fff3cd',
                            borderRadius: '8px',
                            color: '#856404',
                            marginTop: '20px'
                        }}>
                            <h3 style={{ marginBottom: '8px' }}>No Co-Hosted Shows</h3>
                            <p>You are not listed as a co-host in any shows yet.</p>
                        </div>
                    ) : (
                        <div className="more-stories">
                            {shows.map(show => {
                                const sub = show.subtopics?.[0];
                                return (
                                    <article
                                        key={show.id}
                                        className="grid-tile"
                                        onClick={() => navigate(`/read-more/${show.id}`)}
                                        style={{ position: 'relative' }}
                                    >
                                        {sub?.image_urls?.[0] ? (
                                            <img src={sub.image_urls[0]} alt={show.title} />
                                        ) : (
                                            <div className="placeholder-img" />
                                        )}
                                        <div className="grid-text">
                                            <div className="tile-head">
                                                <h4 dangerouslySetInnerHTML={{ __html: show.title }} />
                                            </div>
                                            <p className="meta">
                                                <FaCalendarAlt /> {show.show_date} {show.start_time}
                                            </p>
                                        </div>
                                        <button
                                            onClick={(e) => {
                                                e.stopPropagation();
                                                navigate(`/admin-panel?showId=${show.id}`);
                                            }}
                                            style={{
                                                position: 'absolute',
                                                bottom: '10px',
                                                right: '10px',
                                                background: 'rgba(13, 110, 253, 0.9)',
                                                color: 'white',
                                                border: 'none',
                                                borderRadius: '50%',
                                                width: '40px',
                                                height: '40px',
                                                cursor: 'pointer',
                                                display: 'flex',
                                                alignItems: 'center',
                                                justifyContent: 'center',
                                                fontSize: '16px',
                                                transition: 'background 0.3s ease',
                                                zIndex: 10,
                                            }}
                                            onMouseEnter={(e) => e.target.style.background = 'rgba(13, 110, 253, 1)'}
                                            onMouseLeave={(e) => e.target.style.background = 'rgba(13, 110, 253, 0.9)'}
                                            title="Edit show"
                                        >
                                            <FaEdit />
                                        </button>
                                    </article>
                                );
                            })}
                        </div>
                    )}
                </div>
            )}
        </div>
    );
};

export default MyShows;
